import React, { useState, useCallback, useMemo, useContext } from 'react';
import { getAllFields } from '../../../../internal-components/form-builder/getAllFields';
import { isFieldPlaceHolderAllowed } from '../../../engine/EmailDialogEngine';
import { FormBuilderContext } from '../../../engine/FormBuilderEngine';
import { AutomationActionsContext } from '../../engine/AutomationsActionsEngine';
import ActionEmailTemplateEditorView from '../view/ActionEmailTemplateEditorView';

const ActionEmailTemplateEditorEngine = ({
  templateId,
  setTemplateId,
  emailDialogProps = {},
  onOpenEmailDialogClicked: givenOnOpenEmailDialogClicked,
  isEmailDialogOpen: givenIsEmailDialogOpen,
  setIsEmailDialogOpen: givenSetIsEmailDialogOpen,
  containerCSS,
  ...props
}) => {
  const [_isEmailDialogOpen, _setIsEmailDialogOpen] = useState(false);
  const [templateCode, setTemplateCode] = useState(null);

  const isEmailDialogOpen = useMemo(
    () => givenIsEmailDialogOpen || _isEmailDialogOpen,
    [givenIsEmailDialogOpen, _isEmailDialogOpen]
  );
  const setIsEmailDialogOpen = useMemo(
    () => givenSetIsEmailDialogOpen || _setIsEmailDialogOpen,
    [givenSetIsEmailDialogOpen]
  );

  const { form } = useContext(FormBuilderContext);
  const { mailTemplates } = useContext(AutomationActionsContext);

  const forceTemplateCreation = useMemo(
    () => !!(mailTemplates || []).find(temp => temp.id === templateId),
    [templateId, mailTemplates]
  );

  const onEmailDialogClosed = useCallback(() => {
    setIsEmailDialogOpen(false);
  }, [setIsEmailDialogOpen]);

  const fieldPlaceHolders = useMemo(() => {
    const allFields = getAllFields(form);

    const additionalPlaceHolders = allFields.map(field => ({
      value: field.internalId,
      text: field.title || `Untitled ${field.uiType} field`,
      'data-testid': `placeholder-field-${field.internalId}`
    }));
    additionalPlaceHolders.push({
      value: 'referenceId',
      text: 'referenceId',
      'data-testid': `placeholder-field-child.referenceId`
    });

    return isFieldPlaceHolderAllowed(templateCode)
      ? additionalPlaceHolders
      : [];
  }, [templateCode]);

  const onEmailReducerChange = useCallback(data => {
    setTemplateCode(data.code);
  }, []);

  const onOpenEmailDialogClicked = useCallback(() => {
    setIsEmailDialogOpen(true);
    givenOnOpenEmailDialogClicked && givenOnOpenEmailDialogClicked();
  }, [givenOnOpenEmailDialogClicked, setIsEmailDialogOpen]);

  const viewProps = {
    isEmailDialogOpen,
    setIsEmailDialogOpen,
    onEmailDialogClosed,
    templateId,
    setTemplateId,
    fieldPlaceHolders,
    onEmailReducerChange,
    emailDialogProps,
    onOpenEmailDialogClicked,
    containerCSS,
    forceTemplateCreation,
    ...props
  };

  return <ActionEmailTemplateEditorView {...viewProps} />;
};
export default ActionEmailTemplateEditorEngine;
